import { SessionActionUnion, SessionActionTypes } from './actions';
import { SessionState } from './state';

const sessionDefaultState: SessionState = {
  session: undefined,
  loaded: false,
  loading: false,
  error: undefined
};

export function sessionReducer(
  state: SessionState = sessionDefaultState,
  action: SessionActionUnion
): SessionState {
  switch (action.type) {
    case SessionActionTypes.Load:
      return {
        ...state,
        session: undefined,
        loaded: false,
        loading: true,
        error: undefined
      };
    case SessionActionTypes.LoadSuccess:
      return {
        ...state,
        session: action.payload,
        loaded: true,
        loading: false,
        error: undefined
      };
    case SessionActionTypes.LoadFailed:
      return {
        ...state,
        session: undefined,
        loaded: false,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}

export const getSession = (state: SessionState) => state.session;

export const getSessionLoaded = (state: SessionState) => state.loaded;
